import { useNotify, useRefresh } from "ra-core";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

interface RefreshEmailsButtonProps {
  size?: "sm" | "default";
  variant?: "outline" | "ghost" | "default";
  className?: string;
}

/**
 * Recharge la liste des messages déjà ingérés.
 *
 * Ce bouton appelait l'edge function `trigger_email_sync`, qui relayait vers un
 * proxy HTTP. Ce proxy n'existe plus : la sync IMAP tourne en timer systemd sur
 * mail.fabrik.so toutes les 15 minutes (cf. deploy/email-sync/README.md), et la
 * fonction répondait 503 à chaque clic. Il n'y a rien à déclencher depuis le
 * navigateur — seulement à relire ce que le worker a écrit.
 */
export const RefreshEmailsButton = ({
  size = "sm",
  variant = "outline",
  className,
}: RefreshEmailsButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => {
        refresh();
        notify("Liste actualisée (la sync IMAP tourne toutes les 15 min)", {
          type: "info",
        });
      }}
      className={className}
    >
      <RefreshCw className="w-4 h-4" />
      Actualiser
    </Button>
  );
};
